<template>
  <StageTeaserV2
    :asset-mode="mgnlPropsWithBtnColors.assetMode"
    :asset-position="mgnlPropsWithBtnColors.assetPosition"
    :markup-tag="mgnlPropsWithBtnColors.markupTag"
    :markup-tag-color="mgnlPropsWithBtnColors.markupTagColor"
    :title="mgnlPropsWithBtnColors.title"
    :title-color="mgnlPropsWithBtnColors.titleColor"
    :subtitle="mgnlPropsWithBtnColors.subtitle"
    :subtitle-color="mgnlPropsWithBtnColors.subtitleColor"
    :background-color="mgnlPropsWithBtnColors.backgroundColor"
    :heading-tag="mgnlPropsWithBtnColors.headingTag"
    :position="mgnlPropsWithBtnColors.position"
    :image-load-type="(mgnlPropsWithBtnColors.imageLoadType as ('eager' | 'lazy'))"
    :cta-link="mgnlPropsWithBtnColors.ctaLink"
    :cta-text-color="mgnlPropsWithBtnColors.ctaTextColor"
    :button-color="mgnlPropsWithBtnColors.buttonColor"
    :border-color="mgnlPropsWithBtnColors.borderColor"
    :data-ab-id="mgnlProps.dataABId"
    :enable-legal-disclaimer="mgnlProps.enableLegalDisclaimer"
    :legal-text="mgnlProps.legalText"
    :legal-title="mgnlProps.legalTitle"
    :title-or-subtitle="mgnlProps.titleOrSubtitle"
  />
</template>

<script lang="ts" setup>
import StageTeaserV2 from '~/components/Shared/Teaser/Stage/v2/StageTeaserV2.vue';
import { StageTeaserV2Builder, WrapperProps } from '~/components/Shared/Teaser/Stage/v2/StageTeaserV2.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const { $domain } = useNuxtApp();

const props = defineProps({
  ...WrapperProps, pageLink: String, ctaText: String, ctaTargetMode: String, pdfLinkInDam: Object, showCtaAsPdf: Boolean,
});

const {
  markupTagColor, titleColor, subtitleColor, backgroundColor,
} = toRefs(props);

const mgnlProps = {
  ...StageTeaserV2Builder.build(props),
  markupTagColor: magnoliaGetters.getHexColor(markupTagColor?.value),
  titleColor: magnoliaGetters.getHexColor(titleColor?.value),
  subtitleColor: magnoliaGetters.getHexColor(subtitleColor?.value),
  backgroundColor: magnoliaGetters.getHexColor(backgroundColor?.value),
  assetMode: {
    ...props.assetMode,
    thumbnail: magnoliaGetters.getDefaultSrcAsset(props.assetMode?.thumbnail?.thumbnail0.image, $domain.cmsAssetDomainPath ?? ''),
  },
};

if (props.pageLink && !props.ctaLink) {
  magnoliaGetters.migratePageLinkToCtaLink(mgnlProps, props);
}

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  ctaTextColor: mgnlProps.ctaLink?.[0]?.ctaTextColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.ctaTextColor) : '#ffffff',
  buttonColor: mgnlProps.ctaLink?.[0]?.buttonColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.buttonColor) : '#3c3c3b',
  borderColor: mgnlProps.ctaLink?.[0]?.borderColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.borderColor) : '#3c3c3b',
};
</script>
